import '.bt{flex-shrink:0;}.ssr-plugin'
import '.bv{padding:1rem;}.ssr-plugin'
import '.a1{width:100%;}.ssr-plugin'
import '.bk{height:100%;}.ssr-plugin'
import '.ar{border:none;}.ssr-plugin'
import '.as{background-color:transparent;}.ssr-plugin'
import '.g3{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ak{align-items:stretch;}.ssr-plugin'
import '.dm{position:sticky;}.ssr-plugin'
import '.g4{top:4rem;}.ssr-plugin'
import '.g5{z-index:7;}.ssr-plugin'
import '.ac{background-color:var(--shades-white);}.ssr-plugin'
import '.g6{padding-bottom:1rem;}.ssr-plugin'
import '.p{margin-bottom:1rem;}.ssr-plugin'
import '.g7{border-bottom:var(--blue-border);}.ssr-plugin'
import '.y{position:fixed;}.ssr-plugin'
import '.bx{top:0;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.g8{bottom:0px;}.ssr-plugin'
import '.e7{z-index:9999;}.ssr-plugin'
import '.g9{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cv{justify-content:flex-end;}.ssr-plugin'
import '.ce{flex:1;}.ssr-plugin'
import '.b8{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bt bv a1 bk ar as g3"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ak"
    >
      <div className="dm g4 g5 ac g6 p g7 a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="y bx bi bj g8 e7 ac g9 a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bv a cv g7"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="ce b8">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
